// @ts-strict-ignore
import {Directive, Input, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {SohoHomePageComponent} from 'ids-enterprise-ng';
import {Observable, Observer, of} from 'rxjs';
import {LMThemeService} from '@banner/lm-theme.service';
import {LMRefreshRequest} from "@app/components";

@Directive()
export abstract class LMDashboardPanelBaseComponent {

  /**
   * The number of columns the card should layout into (given available space).
   */
  @Input() columns: number;
  @Input() set fromDataView(dataView: LMDataView) {};

  @ViewChild(SohoHomePageComponent) sohoHomepageComponent: SohoHomePageComponent;

  constructor(protected lmThemeService: LMThemeService) {}

  isModified(): boolean {
    return false;
  }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return of(true)
  }

  save(callBack: Observer<boolean>) {
    callBack.next(true);
    callBack.complete();
  }

  abstract saveDashboardPanelState(): void;
  abstract clearDashboardPanelState(): void;
}
